<template>
  <div>
    <v-card class="pa-4 elevation-1">
      <v-card-title class="text-subtitle-1 font-weight-bold">
        {{ $t('common.filter') }}
      </v-card-title>
      <v-card-text>
        <v-form>
          <v-row>
            <v-col cols="12" sm="6" md="4" lg="2">
              <v-select
                v-model="filters.country"
                :items="countryOptions"
                :label="$t('diagnostics.filter_by_country')"
                item-text="name"
                item-value="code"
                outlined
                dense
              >
                <template v-slot:selection="{ item }">
                  <span v-if="item">{{ item.flag }} {{ item.name }}</span>
                </template>
                <template v-slot:item="{ item }">
                  <span v-if="item">{{ item.flag }} {{ item.name }}</span>
                </template>
              </v-select>
            </v-col>
            <v-col cols="12" sm="6" md="4" lg="2">
              <v-select
                v-model="filters.grade"
                :items="gradeOptions"
                :label="$t('diagnostics.filter_by_grade')"
                item-text="text"
                item-value="value"
                clearable
                outlined
                dense
              />
            </v-col>
            <v-col cols="12" sm="6" md="4" lg="2">
              <v-select
                v-model="filters.level"
                :items="levelOptions"
                :label="$t('diagnostics.level')"
                item-text="text"
                item-value="value"
                clearable
                outlined
                dense
              />
            </v-col>
            <v-col cols="12" sm="6" md="4" lg="2">
              <v-select
                v-model="filters.variant"
                :items="variantOptions"
                :label="$t('diagnostics.variant')"
                item-text="text"
                item-value="value"
                clearable
                outlined
                dense
              />
            </v-col>
            <v-col cols="12" sm="6" md="4" lg="2">
              <v-text-field
                v-model="filters.search"
                :label="$t('diagnostics.search_placeholder')"
                prepend-inner-icon="mdi-magnify"
                clearable
                outlined
                dense
              />
            </v-col>
            <v-col cols="12" sm="6" md="8" lg="2" class="d-flex align-center diagnostics-actions">
              <v-btn
                color="deep-purple lighten-1"
                dark
                @click="handleSearch"
                :disabled="loading"
                class="mr-2"
                small
              >
                {{ $t('diagnostics.search') }}
              </v-btn>
              <v-btn
                color="grey"
                text
                @click="handleReset"
                :disabled="loading"
                small
              >
                {{ $t('diagnostics.clear_filters') }}
              </v-btn>
            </v-col>
          </v-row>
        </v-form>
      </v-card-text>
    </v-card>
  </div>
</template>

<script>
import { SUPPORTED_COUNTRIES, GRADES } from '@/constants/diagnostics';

export default {
  name: 'DiagnosticsFilter',
  props: {
    value: { type: Object, default: () => ({}) },
    loading: { type: Boolean, default: false },
  },
  data() {
    const defaultFilters = this.getDefaultFilters();

    return {
      filters: defaultFilters,
      countryOptions: [
        { code: 'GENERAL', name: 'General', flag: '🌐' },
        ...SUPPORTED_COUNTRIES,
      ],
      gradeOptions: [
        { value: null, text: this.$t('diagnostics.all_grades') },
        ...GRADES,
      ],
      levelOptions: [
        { value: null, text: this.$t('diagnostics.all_levels') },
        { value: 'INITIAL', text: this.$t('diagnostics.levels.INITIAL') },
        { value: 'INTERMEDIATE', text: this.$t('diagnostics.levels.INTERMEDIATE') },
        { value: 'ADVANCED', text: this.$t('diagnostics.levels.ADVANCED') },
      ],
      variantOptions: [
        { value: null, text: this.$t('diagnostics.all_variants') },
        { value: 'WITH', text: this.$t('diagnostics.has_variant') },
        { value: 'WITHOUT', text: this.$t('diagnostics.no_variant') },
      ],
    };
  },
  watch: {
    value: {
      immediate: true,
      handler(newValue) {
        if (newValue) {
          this.filters = { ...newValue };
        }
      },
    },
  },
  methods: {
    getDefaultFilters() {
      return {
        country: 'GENERAL',
        grade: null,
        level: null,
        variant: null,
        search: '',
      };
    },
    handleSearch() {
      this.$emit('search', this.filters);
    },
    handleReset() {
      this.filters = this.getDefaultFilters();
      this.$emit('reset');
    },
  },
};
</script>

<style scoped>
.v-btn {
  cursor: pointer;
}

.diagnostics-actions {
  flex-wrap: wrap;
  gap: 8px;
}

.diagnostics-actions .v-btn {
  margin-right: 0 !important;
}
</style>
